import Link from 'next/link';
import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import type { ISearchFallbackScenariosProps } from '..';
import { ScSearchFallbackScenario } from '../styled';

type JackpotScenarioProps = ISearchFallbackScenariosProps;

export const JackpotScenario: React.FC<JackpotScenarioProps> = ({
  sendSearchResultAppearance,
}) => {
  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>
          <Trans
            components={{
              l: <Link className="link" href="/jackpot" />,
              s: <strong />,
            }}
            i18nKey="searchFallback.subtitle.jackpot"
            ns="lobby"
          />
        </p>
      </div>
    </ScSearchFallbackScenario>
  );
};
